import React from 'react';

import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';

interface IExpandActionButtonProps extends IBaseActionButtonProps {
  playing: boolean;
}

const PlayActionButton = (props: IExpandActionButtonProps) => {
  return (
    <BaseActionButton {...props}>
      {!props.playing && <PlayArrowIcon />}
      {props.playing && <PauseIcon />}
    </BaseActionButton>
  );
};

export default PlayActionButton;
